module.exports = __webpack_public_path__ + "img/vip-v.59494367.png";